import React, { useState, useCallback } from 'react'
import {
  Layout,
  Page,
  TextContainer,
  Heading,
  CalloutCard,
  Link,
  FooterHelp
} from '@shopify/polaris'

export default function Settings(props) {
  return (
    <Page
      title="PiknPak"
    >
      <Layout>
        <Layout.Section>
          <TextContainer spacing="loose">
            <Heading>Summarize the line items from multiple orders</Heading>
            <p>
              PiknPak lets you combine multiple orders into a single list of items which you can print and bring with you into your warehouse. Pick the items from the summary list, then bring them all back at once to be packed.
            </p>
          </TextContainer>
        </Layout.Section>
        <Layout.Section>
          <CalloutCard
            title="Use PiknPak from your Orders page"
            illustration="/images/orders.svg"
            primaryAction={{
              content: 'Take me to my orders page',
              url: 'https://' + props.shop_url + '/admin/orders',
              external: true
            }}
          >
            <p>Read the detailed instructions down below, then head to your orders page to use PiknPak.</p>
          </CalloutCard>
        </Layout.Section>
        <Layout.Section>
          <TextContainer spacing="loose">
            <Heading>Usage instructions</Heading>
          </TextContainer>
          <Layout.AnnotatedSection
            title="Step 1"
            description="From your store's Orders page, select all the orders which you would like summarized. Then select 'More actions' > 'Generate Summary'."
          >
            <img src="/images/select-orders.png" className="documentation-image" />
          </Layout.AnnotatedSection>
          <Layout.AnnotatedSection
            title="Step 2"
            description="PiknPak will generate a list of line items. These represent a combination of all the similar line items from all selected orders."
          >
            <img src="/images/click-print.png" className="documentation-image" />
          </Layout.AnnotatedSection>
          <Layout.AnnotatedSection
            title="Step 3"
            description="Click print! Take the printed list back with you to the warehouse and get all the inventory you need in order to pack your orders in a single trip."
          >
            <img src="/images/print.png" className="documentation-image" />
          </Layout.AnnotatedSection>
        </Layout.Section>

      </Layout>
      {/* <FooterHelp>
        Love PiknPak? Consider making a contribution to help it's development and keep it free.
        <p style={{ textAlign: "center" }}>
          <Link url={"/donate-10?token=" + props.jwt}>$10</Link>&nbsp;&nbsp;&nbsp;&nbsp;
          <Link url={"/donate-25?token=" + props.jwt}>$25</Link>&nbsp;&nbsp;&nbsp;&nbsp;
          <Link url={"/donate-50?token=" + props.jwt}>$50</Link>
        </p>
      </FooterHelp> */}
    </Page>
  )
}